import { ArrowUpRight, Wand2 } from 'lucide-react'
import { MeshHeroBackground } from '../MeshHeroBackground'
import { AgentWorkspace } from '../AgentWorkspace'
import { SelfHostMenu } from './SelfHostMenu'

const heroBody =
  'Trace, test, route and govern every LLM call in your company, from your own agents to the coding assistants your engineers use.'

// The four jobs the platform covers, in the order a platform team adopts them.
const heroChips = [
  { label: 'LLM Ops', href: '/llm-observability' },
  { label: 'Coding Agents', href: '/claude-code-usage' },
  { label: 'AI Gateway', href: '/gateway' },
  { label: 'AI Governance', href: '/ai-governance' },
]

function AnnouncementPill() {
  return (
    <a
      href="/langy"
      className="mb-[22px] inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-brand-500/10 px-2.5 py-1 text-[11.5px] font-medium tracking-[-0.005em] text-brand-700 no-underline transition-colors"
    >
      <Wand2 className="h-3.5 w-3.5" />
      Introducing Langy
      <ArrowUpRight className="h-3.5 w-3.5" />
    </a>
  )
}

function Actions({ inverse = false }: { inverse?: boolean }) {
  return (
    <div className="mt-8 flex flex-wrap items-center gap-3">
      <a
        href="/get-a-demo"
        data-nav-dark={inverse ? undefined : true}
        className={
          inverse
            ? 'inline-flex items-center gap-2 rounded-full bg-white px-5 py-3 text-sm font-semibold text-ink-950'
            : 'btn-primary !px-5 !py-3'
        }
      >
        Book a demo
      </a>
      <SelfHostMenu inverse={inverse} />
    </div>
  )
}

export function VariantHero() {
  return (
    <section className="relative isolate -mt-16 overflow-hidden bg-white">
      {/* Mesh band — sits behind the nav + heading and runs down behind the top of the windows.
          Mobile gets a shallower band (less pb/-mt) so the workspace/console peeks into view
          sooner on scroll, rather than the desktop-tuned offsets keeping it fully below the fold. */}
      <div className="relative pt-32 pb-[260px] md:pt-28 md:pb-[430px]">
        <MeshHeroBackground protectSide="left" fadeBottom />
        <div className="container-wide relative z-10">
          <div className="max-w-[760px]">
            <AnnouncementPill />
            <h1 className="display text-[34px] text-ink-900 sm:text-[42px] md:text-[52px]">
              Agent Observability &amp; Evals
              <br />
              for <span className="text-brand-600">AI Platform teams</span>
            </h1>
            <p className="mt-8 max-w-[610px] text-[17px] leading-[1.65] text-[#39445c]">
              {heroBody}
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-2">
              {heroChips.map((c) => (
                <a key={c.label} href={c.href} className="pill no-underline transition-colors hover:border-ink-300 hover:text-ink-700">
                  {c.label}
                </a>
              ))}
            </div>
            <Actions />
          </div>
        </div>
      </div>

      {/* Workspace pulled up so the mesh fades out around the middle of the windows */}
      <div className="container-wide relative z-10 -mt-[200px] md:-mt-[350px]">
        <AgentWorkspace />
      </div>
    </section>
  )
}
